<div class="annex-group-view-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" fxLayoutGap="15px" fxFlex="100" >
    <mat-card class="mat-elevation-z2" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row">
      <div fxLayout="row">
        <h3>Dane z formularza</h3>
      </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="15px" fxFlex="100">
        <div fxFlex="100">
          <div class="grid-container">
            <ng-container >
              <div *ngFor="let item of formRow.data"  [ngClass]="{'grid-header': item.type === 'header' || item.type === 'array', 'grid-item': item.type !== 'header'}">
                <app-detail [header]="item.name" fxFlex="100" *ngIf="item.type === 'array'">
                  <mat-chip-list >
                    <mat-chip selected color="accent" *ngFor="let item2 of item.splitValues" (click)="copyMessage(item2)">{{ item2 }}</mat-chip>
                  </mat-chip-list>
                </app-detail>

                <app-detail [header]="item.type !== 'header' ? item.name : null" [value]="item.value" *ngIf="item.type !== 'array' && item.type !== 'header' && item.type !== 'boolean'" (click)="copyMessage(item.value)"></app-detail>
                <app-detail [header]="item.name"  *ngIf="item.type === 'boolean'">
                  <app-detail-bool [value]="item.value === 'true'"></app-detail-bool>
                </app-detail>
                <div class="grid-header-style" *ngIf="item.type === 'header'"> <b> {{item.value}} </b> </div>
              </div>
            </ng-container>
          </div>

        </div>

      </div>

    </mat-card>
  </div>
</div>
